import { Icon } from "@/components/ui/Icon";
import { AddressSuggestionsProps } from "./types";
import { tr } from "@/config/localeText";
import { RESERVATION_UI } from "./reservationFormUi";

export const AddressSuggestions = ({
  suggestions,
  onSelect,
  isLoading,
  show,
  locale = "fr",
}: AddressSuggestionsProps) => {
  if (!show) return null;
  const t = tr(RESERVATION_UI, locale).suggestions;

  const getPoiTypeLabel = (type: string) => {
    if (type === "gare") return t.gare;
    if (type === "aeroport") return t.aeroport;
    if (type === "destination") return t.destination;
    if (type === "hotel") return t.hotel;
    return t.poi;
  };

  return (
    <div
      className="absolute left-0 right-0 top-full z-40 mt-1 h-32 overflow-y-auto rounded-lg border border-black/15 bg-white shadow-[0_10px_28px_rgba(0,0,0,0.12)]"
      onClick={(e) => e.stopPropagation()}
    >
      {isLoading ? (
        <div className="flex h-full items-center justify-center">
          <Icon
            icon="ph:spinner"
            className="h-5 w-5 animate-spin text-gold-700"
          />
        </div>
      ) : suggestions.length > 0 ? (
        suggestions.map((suggestion) => (
          <div
            key={suggestion.id}
            className="cursor-pointer px-4 py-2 hover:bg-black/5"
            onClick={() => onSelect(suggestion)}
          >
            <div className="flex items-center gap-2">
              <Icon
                icon={
                  suggestion.isPOI && suggestion.icon
                    ? suggestion.icon
                    : "ph:map-pin"
                }
                className="h-5 w-5 text-gold-700"
              />
              <div className="flex-1 overflow-hidden">
                <div className="flex items-center gap-2">
                  <span className="truncate font-medium text-black">
                    {suggestion.isPOI ? suggestion.name : suggestion.label}
                  </span>
                  {suggestion.isPOI && (
                    <span className="text-xs text-black/70">
                      ({getPoiTypeLabel(suggestion.type)})
                    </span>
                  )}
                </div>
                <div className="truncate text-sm text-black/70">
                  {suggestion.isPOI
                    ? suggestion.label
                    : `${suggestion.postcode} ${suggestion.city}`}
                  {suggestion.context && !suggestion.isPOI && (
                    <span className="ms-1 text-xs text-black/60">
                      ({suggestion.context})
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="flex h-full items-center justify-center text-black/70">
          Aucune suggestion trouvée
        </div>
      )}
    </div>
  );
};
